import { IReminderService } from "../../core/impl/reminderServiceImpl";

export type IReminderController = ReturnType<typeof ReminderControllerFactory>;

export const ReminderControllerFactory = ({
  reminderService,
}: {
  reminderService: IReminderService;
}) => {
  return {
    getReminders: reminderService.getReminders,
    getReminderById: reminderService.getReminderById,
    createReminder: reminderService.createReminder,
    updateReminder: reminderService.updateReminder,
    deleteReminder: reminderService.deleteReminder,
  };
};
